module.exports = __webpack_public_path__ + "img/box3.821c03fc.png";